<template>
  <div>
    <!-- <GroupList :accessToken="accessToken" />
    <div class="column">
      <button class="button is-warning is-fullwidth" @click="fullLogout()">
        <span class="icon">
          <i class="fas fa-door-open fa-fw" />
        </span>
        <span>Logout (Full)</span>
      </button>
    </div>-->
    <div class="crm-top cases-top">
      <div class="cases-top-left">
        <div class="case-tabs">
          <router-link to="/osobe">
            <div class="case-tab case-tab-osobe active">Osobe</div>
          </router-link>
          <router-link to="/institucije">
            <div class="case-tab case-tab-institucije">Institucije</div>
          </router-link>
        </div>
      </div>
      <div class="cases-top-right">
        <router-link to="/nova-osoba" class="add-case">
          Unesi novu osobu
          <div class="add-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </router-link>
      </div>
      <div class="crm-line">
        <div class="letter-search">
          <div
            :class="slovo_pretrazivanja == 'Sve' ? 'ls active' : 'ls'"
            @click="slovo_pretrazivanja = 'Sve'"
          >
            <div class="inner-ls" @click="tableAnim">Sve</div>
          </div>
          <div
            :class="slovo == slovo_pretrazivanja ? 'ls active' : 'ls'"
            v-for="(slovo, idx) in slova"
            :key="idx"
            @click="slovo_pretrazivanja = slovo"
          >
            <div class="inner-ls" @click="tableAnim">{{ slovo }}</div>
          </div>
        </div>
        
        <div class="crm-dropdown">
          Prikaz:
            <select id="search-group" v-model="person_type">
              <option value="0">Sve uloge</option>
              <option value="1">Članovi tima</option>
              <option value="2">Stranke</option>
              <option value="3">Protustranke</option>
              <option value="4">Službene osobe</option>
              <option value="5">Ostali</option>
              <option value="6">Drugi sudionici</option>
            </select>
            <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
        </div>
      </div>
    </div>
    <div class="testtable">
      <div v-if="fetching" class="paznja-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
      <table v-else class="responstable">
        <tr>
          <th>Osoba<div class="downarrow"></div></th>
          <th data-th="Detalji osobe"><span>Datum upisa</span><div class="downarrow"></div></th>
          <th>Upisan od<div class="downarrow"></div></th>
          <th>Uloga<div class="downarrow"></div></th>
          <th>Telefon<div class="downarrow"></div></th>
          <th>E-mail<div class="downarrow"></div></th>
          <th>Predmeti<div class="downarrow"></div></th>
        </tr>
        
        <tr v-for="(pers, idx) in finalni_arr_prikaza" :key="idx">
          <td>
            <router-link :to="'/osobe/' + pers.url"
              >{{ pers.prezime }} {{ pers.ime }}</router-link
            >
          </td>
          <td><span>{{ switchDate(pers.datum_upisa) }}</span></td>
          <td>
            <div v-if="pers.upisan_od !=null ">
              <router-link  :to="'/osobe/law/' + pers.upisan_od.uid"
              >{{ pers.upisan_od.ime }} {{ pers.upisan_od.prezime }}</router-link
            >
            </div>
          </td>
          <td>{{ pers.uloga }}</td>
          <td>
          <div v-if="pers.telefon.length > 0">
            {{pers.telefon[0]}}
          </div>
            <v-tooltip
                right
                v-if="pers.telefon.length > 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                  <img
                    v-bind="attrs"
                    v-on="on"
                    class="more-dots"
                    src="@/assets/img/more.svg"
                  />
                </template>
                <p
                  v-for="(tel, key) in pers.telefon"
                  :key="key"
                  >{{ tel }}</p
                >
            </v-tooltip>
          </td>
          <td>
            <a
              v-if="pers.email.length > 0"
              :href="'mailto:' + pers.email[0]"
              >{{ pers.email[0] }}</a
            >
            <v-tooltip
                right
                v-if="pers.email.length > 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                  <img
                    v-bind="attrs"
                    v-on="on"
                    class="more-dots"
                    src="@/assets/img/more.svg"
                  />
                </template>
                <p v-for="(mail, key) in pers.email" :key="key">
                  {{ mail }}
                </p>
              </v-tooltip>
          </td>
          <td>
            <router-link
              v-if="pers.predmeti.length > 0"
              :to="'/case/' + pers.predmeti[pers.predmeti.length-1].predmet.group_url + '/'"
              >{{ pers.predmeti[pers.predmeti.length-1].predmet.ime_predmeta }}</router-link
            >
            <v-tooltip
                right
                v-if="pers.predmeti.length > 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                  <img
                    v-bind="attrs"
                    v-on="on"
                    class="more-dots"
                    src="@/assets/img/more.svg"
                  />
                </template>
                <p v-for="(predmet, key) in pers.predmeti" :key="key">
                  {{ predmet.predmet.ime_predmeta }}
                </p>
              </v-tooltip>
          </td>
        </tr>
      </table>
    </div>

    <div class="cases-pagination">
      <div class="cases-pagination-left">
        <div class="pagin-wrapp page-nav" v-if="all_pages.length>1">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length>1">
          <div :class="{ 'curr-page': curr_page == all_pages.length }"
            @click="setPage(all_pages.length)">
            {{ all_pages.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <!-- <img style="width:16rem;" src="../assets/img/paginacija2.svg"> -->
      </div>
      <div class="cases-pagination-right">
        Broj redova po stranici
        <div class="broj-redova">
          <select id="search-group" v-model="br_redova">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="11"
            viewBox="0 0 7 11"
          >
            <g>
              <g>
                <path
                  fill="#3326ae"
                  d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z"
                />
              </g>
              <g>
                <path
                  fill="#3326ae"
                  d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
    <cu-fizicka
      v-if="inputFizVis"
      :fizicka_osoba="undefined"
      :isNew="true"
    ></cu-fizicka>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import CuFizicka from "@/components/personComponents/createUpdateSudionici/CUFizicka.vue";
import gsap from "gsap";

export default {
  components: { CuFizicka },
  data() {
    return {
      slovo_pretrazivanja: "",

      ukupna_lista: [],
      finalni_arr_prikaza: [],

      accessToken: "",
      all_osobe: [],
      fetching: true,
      slova: [],
      inputFizVis: false,
      all_pages: [],
      curr_page: 1,
      br_redova: 5,
      left_dots_visible: false,
      right_dots_visible: false,
      person_type: 0
    };
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    this.getAllPersons();
    
  },
  computed: {
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.all_pages.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
  },
  watch: {
    slovo_pretrazivanja: function () {
      this.curr_page = 1;
      this.filterPersons();
    },
    curr_page: function () {
      this.paginiraj_odabrane();
    },
    person_type : function()
    {
      this.getAllPersons();
      this.curr_page=1;
    },
    br_redova: function(){
      this.filterPersons();
      if (this.curr_page > this.all_pages.length) {
        this.curr_page = this.all_pages[this.all_pages.length-1];
      }
    }
  },
  methods: {
    getAllPersons()
    {
      this.all_osobe = [];
      this.slova = [];
      this.fetching = true
      osoba.getAllOsobe(this.person_type).then((resp) => {
      resp.data.forEach((p) => {
        if (!this.slova.includes(p.prezime.substring(0, 1).toUpperCase())) {
          this.slova.push(p.prezime.substring(0, 1).toUpperCase());
        }
        this.all_osobe.push(p);
      });

      // this.all_osobe.sort((a, b) => (a.prezime > b.prezime && 1) || -1);
      this.all_osobe.sort((a, b) => (a.prezime.toUpperCase().localeCompare(b.prezime.toUpperCase(),'hr', { sensitivity: 'base' })) );
      this.slova.sort((a, b) => a.localeCompare(b, 'hr', { sensitivity: 'base' }));
      this.slovo_pretrazivanja = 'Sve';
      this.filterPersons();
      this.paginiraj_odabrane();
      this.fetching = false;
    });
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    paginiraj_odabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.ukupna_lista.slice(start_idx, end_idx);
    },

    getPosljednjiPredmet(popis_pred) {
      if (popis_pred == undefined) {
        return "";
      }
      // console.log(popis_pred);
      var lista_predmeta = popis_pred.split(",");
      if (lista_predmeta.length > 0) {
        return lista_predmeta[0];
      } else return popis_pred;
    },
    getPosljednjiLink(popis_link) {
      // console.log(popis_link);
      if (popis_link == undefined) {
        return "";
      }
      var url_list = popis_link.split(",");
      if (url_list.length > 0) {
        return url_list[0];
      } else return popis_link;
    },
    filterPersons() {
      var tmp_array = this.all_osobe.slice();
      if (this.slovo_pretrazivanja != "Sve") {
        //filter by letter
        if (this.slovo_pretrazivanja != "") {
          tmp_array = tmp_array.filter((p) => {
            return p.prezime.substring(0, 1).toUpperCase() == this.slovo_pretrazivanja;
          });
        } else {
          if (this.slova.length > 0) {
            this.slovo_pretrazivanja = 'Sve';
            tmp_array = tmp_array.filter((p) => {
              return p.prezime.substring(0, 1) == this.slova[0];
            });
          }
        }
      }
      
      this.ukupna_lista = tmp_array;
      var finalni_broj = this.ukupna_lista.length / this.br_redova;
      this.all_pages = [];
      if (this.ukupna_lista.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      this.paginiraj_odabrane();
    },
    switchDate(inData) {
      if (inData == "-" || inData == null) {
        return "-";
      } else {
        return moment(inData.toString()).format("l");
      }
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    tableAnim() {
      gsap.fromTo(
        ".responstable",
        0.4,
        { x: -10, opacity: 0 },
        { x: 0, opacity: 1 }
      );
    },
  },
  mounted() {
    // paginacija
    this.$store.state.paginacija.title = "Upravljanje osobama i institucijama";
    // body class
    document.body.classList.add("osobe-institucije");
  },
  destroyed() {
    document.body.classList.remove("osobe-institucije");
  },
};
</script>

<style>
</style>